import React from 'react';
import styled from 'styled-components';
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import './Swiper.css';

SwiperCore.use([Pagination]);

const StyledSwiper = styled(Swiper)`
	width: 100%;
	height: 200px;
	& .swiper-wrapper {
		height: auto !important;
	}
	& .swiper-pagination-bullet-active {
		background: #ffbe00;
		width: 16px !important;
		border-radius: 6px !important;
		height: 7px !important;
	}
`;

const StyledSwiperSlide = styled(SwiperSlide)`
	text-align: center;
	font-size: 18px;
	background-color: #fffdf5;
	display: flex;
	justify-content: center;
	align-items: center;

	img {
		display: block;
		width: 150px;
		height: 150px;
		object-fit: contain;
	}
`;

interface SwiperProps {
	images?: { src: string; alt: string }[];
	style?: React.CSSProperties;
}

const CustomSwiper: React.FC<SwiperProps> = ({ images, style = {} }) => {
	return (
		<>
			<Swiper className="styledSwiper" pagination={{ clickable: true }} modules={[Pagination]}>
				{images?.map((image: any) => {
					return (
						<SwiperSlide className="styledSwiperSlide">
							<img src={image?.url || image?.image} alt={image?.alt} />
						</SwiperSlide>
					);
				})}
			</Swiper>
		</>
	);
};

export default CustomSwiper;
